<template>
    <div class="login-in">
        <h3>{{ $TL.loginPersonalCenter }}</h3>
        <div class="login-form">
            <div class="text-error-info" v-if="0">{{ $TL.loginErrorText }}</div>
            <v-form v-model="valid" ref="form" onSubmit="return false;">
                <div class="input-control">
                    <v-text-field
                        v-model="username"
                        :rules="nameRules"
                        :counter="30"
                        :label="$TL.account"
                        prepend-icon="mdi-account"
                        type="text"
                        @keyup.enter="login_in"
                        required
                    ></v-text-field>
                </div>
                <div class="input-control password-ctl">
                    <v-text-field
                        v-model="password"
                        :rules="passwordRules"
                        :counter="20"
                        :label="$TL.passwordPrompt"
                        prepend-icon="mdi-lock"
                        :type="inputType"
                        @keyup.enter="login_in"
                        required
                    ></v-text-field>
                    <v-btn
                        class="check-lock"
                        :ripple="false"
                        @mousedown="check_password(true)"
                        @mouseup="check_password(false)"
                    >
                        <v-icon>mdi-{{ seeIcon }}</v-icon>
                    </v-btn>
                </div>
                <p class="error-info" v-if="errorInfo">{{ errorInfo }}</p>
                <v-btn class="submit-btn gradient-bg def" @click="login_in">{{
                    $TL.login
                }}</v-btn>
            </v-form>
        </div>
    </div>
</template>

<script>
import { regist_login } from "./components/login-regist.js";

export default {
    name: "login-in",
    props: {
        data: {
            type: Object,
            required: false
        }
    },
    data() {
        return {
            valid: false,
            username: "",
            password: "",
            inputType: "password",
            seeIcon: "eye-off",
            nameRules: [
                v => !!v || this.$TL.contentCanNotNull,
                v => v.length <= 30 || this.$TL.lengthCannotExceed30Char
            ],
            passwordRules: [
                v => v.length <= 20 || this.$TL.lengthCannotExceed20Char,
                v => v.length >= 4 || this.$TL.lengthCannotLessThan4digits
            ],
            errorInfo: ""
        };
    },
    components: {},

    created() {},
    mounted() {},
    beforeDestroy() {},
    methods: {
        async login_in() {
            let option = {
                username: this.username,
                password: this.password
            };
            let msg = await regist_login(
                "profile/login",
                this.$refs.form,
                option
            );
            this.errorInfo = msg?.message ?? "";
        },
        check_password(show) {
            if (show) {
                this.inputType = "text";
                this.seeIcon = "eye";
            } else {
                this.inputType = "password";
                this.seeIcon = "eye-off";
            }
        }
    }
};
</script>

<style lang="scss">
.loginIn {
    .v-dialog {
        width: 400px;
    }
}

.login-in {
    padding: 4px 12px 16px 12px;

    h3 {
        margin-bottom: 20px;
    }

    .login-form {
        padding-top: 24px;
        position: relative;

        &::after {
            content: "";
            position: absolute;
            top: 0;
            left: -28px;
            right: -28px;
            height: 1px;

            background-color: rgba(#000000, 0.15);
        }
    }
    .v-form {
        @include flex(null, center, wrap);
    }
    .input-control {
        margin-bottom: 24px;
        width: 94%;
        position: relative;
        @include flex(center, center);

        .v-input.error--text {
            margin-bottom: 10px;
        }

        .v-input {
            border: 1px solid rgba(#000000, 0.15);
            border-radius: 2px;
            height: 40px;
            @include flex(center);
            padding-left: 10px;
            width: 100%;
            flex: 1 1 auto;
            will-change: transform;

            .v-icon {
                font-size: 22px;
            }
        }

        .v-input__slot {
            &::before,
            &::after {
                display: none;
            }
        }

        .v-text-field__slot {
            .v-label {
                width: 100%;
                position: absolute !important;
                font-size: 14px;
                top: 0;
                bottom: 0;
                margin: auto;
            }

            input {
                font-size: 14px;
            }
        }

        .v-text-field__details {
            position: absolute;
            bottom: -20px;
            left: 0;
        }

        .check-lock {
            top: 10px;
        }
    }

    .error-info,
    .text-error-info {
        font-size: 14px;
        color: #ff5252;
        text-align: left;
    }

    .error-info {
        margin-top: -10px;
    }

    .submit-btn {
        width: 92%;
        margin: auto;
    }
}

.login-in,
.regist {
    .password-ctl {
        position: relative;
        .v-input__slot .v-text-field__slot {
            width: 90%;
            flex: none !important;
        }
    }
    .check-lock {
        position: absolute;
        z-index: 20;
        right: 8px;

        border-radius: 50%;
        i {
            font-size: 20px;
        }
    }
}
</style>
